'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FloatingLabel = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Base = require('../Base');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//eslint-disable-next-line no-unused-vars
var FloatingLabel = exports.FloatingLabel = (0, _Base.simpleTag)({
  displayName: 'FloatingLabel',
  tag: 'label',
  classNames: 'mdc-floating-label'
});

exports.default = FloatingLabel;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rmwc/FloatingLabel/index.js
// module id = 378
// module chunks = 10